<template>
  <div v-redirect-if-no-permission:AUTO_REGULATION>
    <v-tabs v-model="active" centered>
      <v-tab :key="0">{{ $t("drivers.blockedCaptains.activeStationBlocks") }}</v-tab>
      <v-tab :key="1">{{ $t("drivers.blockedCaptains.historicalStationBlocks") }}</v-tab>
      <v-tab :key="2">{{ $t("drivers.blockedCaptains.activeLocationBlocks") }}</v-tab>
      <v-tab :key="3">{{ $t("drivers.blockedCaptains.historicalLocationBlocks") }}</v-tab>
    </v-tabs>
    <div>
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex xs6 style="padding: 8px" v-if="active == 1 || active == 3">
              <choose-date
                clearable
                :label="$t('drivers.blockedCaptains.filterByDay')"
                v-model="date_filter"
              ></choose-date>
            </v-flex>
            <v-flex xs6 style="padding: 8px">
              <v-autocomplete
                v-model="selectedCaptain"
                clearable
                dense
                :items="captains"
                :loading="captainLoading"
                :search-input.sync="searchCaptainParam"
                :label="$t('drivers.blockedCaptains.captain')"
                item-text="text"
                item-value="id"
                :placeholder="$t('drivers.blockedCaptains.searchForCaptain')"
                no-filter
                :debounce-search="250"
              >
                <template slot="item" slot-scope="captains">
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="captains.item.first_name + ' ' + captains.item.last_name"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="captains.item.username"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="data"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :rows-per-page-items="[5, 10, 15, 25, 100]"
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr v-if="isLocation">
              <td class="text-xs-center">
                <span>{{ props.item.id }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ props.item.username }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ formatDate(props.item.block_time) }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ formatDate(props.item.unblock_time) }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ props.item.reason }}</span>
              </td>
              <td class="text-xs-center">
                <v-icon
                  v-if="props.item.location"
                  style="cursor: pointer"
                  @click="openLocation(props.item.location)"
                  >visibility</v-icon
                >
              </td>
            </tr>
            <tr v-else :class="[props.item.is_blocked == true && 'blocked']">
              <td class="text-xs-center">
                <span>{{ props.item.id }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ props.item.username }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ props.item.station_name }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ props.item.booking_id }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ formatDate(props.item.blocked_from) }}</span>
              </td>
              <td class="text-xs-center">
                <span>{{ formatDate(props.item.blocked_to) }}</span>
              </td>
              <td class="text-xs-center">
                <span>
                  {{ [$t("common.no"), $t("common.yes")][props.item.blocked] }}
                </span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <v-dialog v-model="locationDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">{{ $t("drivers.blockedCaptains.location") }}</v-card-title>
        <v-card-text style="padding: 0">
          <gmap-map
            v-if="locationMarker"
            :center="locationMarker"
            :zoom="15"
            :options="mapOptions"
            style="width: 100%; height: 400px"
          >
            <gmap-marker :position="locationMarker"></gmap-marker>
          </gmap-map>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="locationDialog = false"
            >{{ $t("common.close") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ChooseDate from "@/components/monaco/input/ChooseDate";
import LoadingComponent from "@/components/LoadingComponent";
import { toInteger } from "lodash";
import moment from "moment";

export default {
  name: "BlockedCaptains",
  title() {
    return this.$t("drivers.blockedCaptains.title");
  },


  components: {
    ChooseDate,
    LoadingComponent,
  },
  data() {
    return {
      active: 0,
      date_filter: "",
      loading: false,
      selectedCaptain: null,
      searchCaptainParam: "",
      captains: [],
      captainLoading: false,
      locationDialog: false,
      locationMarker: null,
      mapOptions: {
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      },
      items: [],
      data: [],
      totalItems: 0,
      pagination: {
        sortBy: "id",
        rowsPerPage: 25,
      },
      url: "blockLogs",
    };
  },
  computed: {
    stationHeaders() {
      return [
        { text: this.$t("drivers.blockedCaptains.id"), value: "id", align: "center" },
        //  { text: "Username", value: "id", sortable: false, align: "center" },
        {
          text: this.$t("drivers.blockedCaptains.captain"),
          value: "username",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("drivers.blockedCaptains.station"),
          value: "station_name",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("drivers.blockedCaptains.booking"),
          value: "booking_id",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("drivers.blockedCaptains.suggestionTime"),
          value: "blocked_from",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("drivers.blockedCaptains.endTime"),
          value: "blocked_to",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("drivers.blockedCaptains.blocked"),
          value: "blocked",
          sortable: false,
          align: "center",
        },
      ];
    },
    locationHeaders() {
      return [
        { text: this.$t("drivers.blockedCaptains.id"), value: "id", align: "center" },
        {
          text: this.$t("drivers.blockedCaptains.captain"),
          value: "username",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("drivers.blockedCaptains.blockTime"),
          value: "block_time",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("drivers.blockedCaptains.unblockTime"),
          value: "unblock_time",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("drivers.blockedCaptains.reason"),
          value: "reason",
          sortable: false,
          align: "center",
        },
        {
          text: this.$t("drivers.blockedCaptains.location"),
          value: "location",
          sortable: false,
          align: "center",
        },
      ];
    },
    isLocation() {
      return this.active == 2 || this.active == 3;
    },
    headers() {
      return this.isLocation ? this.locationHeaders : this.stationHeaders;
    },
  },
  methods: {
    getCaptains() {
      if (!this.searchCaptainParam) {
        return;
      }
      this.captainLoading = true;
      const params = new URLSearchParams();
      params.append("search", this.searchCaptainParam);
      this.axios
        .get(`captain/search`, { params })
        .then((res) => {
          this.captains = res.data.data.map((captain) => ({
            text:
              `${captain.full_name || ""}` + " " + `${captain.username || ""}`,
            ...captain,
          }));
        })
        .finally(() => {
          this.captainLoading = false;
        });
    },
    formatDate(date) {
      if (!date) return "";
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
    openLocation(location) {
      let loc = location;
      if (typeof loc === "string") {
        try {
          loc = JSON.parse(loc);
        } catch (e) {
          loc = null;
        }
      }
      if (!loc || !loc.coordinates) return;
      const lng = loc.coordinates[0];
      const lat = loc.coordinates[1];
      this.locationMarker = { lat, lng };
      this.locationDialog = true;
    },
    getData() {
      this.loading = true;
      const params = new URLSearchParams();

      params.delete("start");
      params.delete("end");
      if (this.isLocation) {
        this.url = "location-block-logs";
        if (this.active == 2) {
          params.append("active", true);
        }
      } else {
        this.url = "blockLogs";
        if (this.active == 0) {
          this.start = moment().format("YYYY-MM-DD [00:00:00]");
          this.end = this.start.replace("00:00:00", "23:59:59");
          console.log(this.start, this.end);
          params.append("blocked_from", this.start);
          params.append("blocked_to", this.end);
        }
      }
      if (this.date_filter != "Invalid date" && this.date_filter) {
        this.start = moment(this.date_filter).format("YYYY-MM-DD HH:mm:ss");

        this.end = moment(this.date_filter)
          .format("YYYY-MM-DD HH:mm:ss")
          .replace("00:00:00", "23:59:59");

        console.log("START");
        console.log(this.start);
        console.log(this.end);
      }
      params.append("page", this.pagination.page);
      params.append("perPage", String(this.pagination.rowsPerPage));
      params.append("sortBy", String(this.pagination.sortBy));
      params.append("descending", String(this.pagination.descending));
      // params.append("time", "RESERVATION");
      // params.append("sortBy", "id");
      // params.append("descending", true);
      if (this.date_filter) {
        params.append("blocked_from", this.start);
        params.append("blocked_to", this.end);
      }
    //  params.append("reservations", true);

      if (this.selectedCaptain)
        params.append("captain_id", String(this.selectedCaptain));

      this.axios
        .get(this.url, { params })
        .then((res) => {
          console.log("data");
          console.log(res);
          this.data = res.data.data.data;
          // this.data = [
          //   {
          //     id: 1,
          //     captain_id: 2,
          //     blocked_from: "111",
          //     blocked_to: "111",
          //   },
          // ];
          this.totalItems = res.data.data.total;
          this.pagination.rowsPerPage = Number(res.data.data.per_page);
          this.loading = false;
          // window.getApp.$emit("SHOW_TOAST", "successfully");
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err, "red");
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getData();
  },
  watch: {
    searchCaptainParam() {
      this.getCaptains();
    },
    selectedCaptain() {
      this.getData();
    },
    date_filter() {
      console.log(this.date_filter);
      this.getData();
    },
    active(val) {
      this.selectedCaptain = null;
      this.date_filter = "";

      console.log("START");
      console.log(this.start);
      console.log(this.end);
      this.getData();
    },
    pagination: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.blocked {
  td {
    span {
      padding: 4px 6px;
      background-color: rgba(220, 39, 39, 0.08);
      border-radius: 4px;
      color: rgb(220, 39, 39);
    }
  }
}
</style>
